<div class="background">
  <div class="container surface-card shadow-3 border-round">
    <img alt="Image" class="image" height="200" src="assets/godh_logo_transparency.png">
    <div class="separator-container">
      <div class="separator"></div>
    </div>
    <div class="p-4 w-full">
      <div class="text-center mb-5">
        <div class="text-900 text-3xl font-medium mb-3">Welcome Back</div>
        <span class="text-600 font-medium line-height-3">Don't have an account?</span>
        <a class="font-medium no-underline ml-2 text-yellow-600 cursor-pointer" queryParamsHandling="preserve" (click)="changeStateToRegister()"
           routerLink="/register-trial">Create today!</a>
      </div>

      <div>
        <label class="block text-900 font-medium mb-1 mt-3" for="email1">Email</label>
        <input [(ngModel)]="username" class="w-full" id="email1" pInputText type="text" (keyup.enter)="loginButtonAction()"
               [problem-details]="problemDetails" problemDetailsKey="username">

        <label class="block text-900 font-medium mb-1 mt-3" for="password1">Password</label>
        <input [(ngModel)]="password" class="w-full" id="password1" pInputText type="password" (keyup.enter)="loginButtonAction()"
               [problem-details]="problemDetails" problemDetailsKey="password">

        <div class="flex align-items-center justify-content-between mb-3 mt-3">
          <div class="flex align-items-center">
          </div>
          <a class="font-medium no-underline ml-2 text-yellow-600 text-right cursor-pointer" (click)="changeStateToForgotPassword()"
             queryParamsHandling="preserve" routerLink="/forgotPassword">Forgot password?</a>
        </div>

        <button (click)="loginButtonAction()" class="w-full">
          Sign In
        </button>
      </div>
    </div>

  </div>
</div>
